import {
  Button,
  Checkbox,
  Indicator,
  Menu,
  type MenuProps,
  type SelectItem,
} from '@mantine/core';
import type React from 'react';
import {useState} from 'react';
import {MdFilterAlt, MdUnfoldMore} from 'react-icons/md';

type Props = MenuProps & {
  title: string;
  items: SelectItem[];
  onChangeMenu?: (value: string[]) => void;
  value: string[];
};

export const MultiSelectMenu: React.FC<Props> = ({
  title,
  items,
  onChangeMenu,
  value,
  ...props
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(value);
  const handleCheckboxChange = (value: string[]) => {
    setSelectedValues(value);
    if (onChangeMenu) {
      onChangeMenu(value);
    }
  };

  return (
    <div className="h-36 flex my-4 pc:gap-12">
      <Menu middlewares={{flip: false, shift: false}} {...props}>
        <Menu.Target>
          <Button
            className="bg-white text-black px-[2px] rounded-[20px] border-none pc:bg-background pc:text-primary"
            variant="outline"
          >
            <div className="flex items-end font-bold pc:items-center pc:px-16 pc:gap-8">
              {selectedValues.length > 0 ? (
                <Indicator
                  size={6}
                  color="red"
                  styles={{
                    indicator: {
                      zIndex: 1,
                    },
                  }}
                >
                  <MdFilterAlt size={16} />
                </Indicator>
              ) : (
                <MdFilterAlt size={16} />
              )}
              <span className="pt-4 pc:p-4">{title}</span>
              <MdUnfoldMore className="text-black-3" size={16} />
            </div>
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Checkbox.Group
            value={selectedValues}
            onChange={handleCheckboxChange}
          >
            {items.map((item) => (
              <Checkbox
                key={item.value}
                className="py-4 px-16"
                styles={{
                  labelWrapper: {
                    width: '100%',
                    userSelect: 'none',
                  },
                }}
                value={String(item.value)}
                label={<span className="w-full mx-auto">{item.label}</span>}
              />
            ))}
          </Checkbox.Group>
        </Menu.Dropdown>
      </Menu>
    </div>
  );
};
